<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>计划管理</h4>
    </div>
    <el-tabs v-model="activeName" style="margin-left:10px;" type="card" @tab-click="tabHandleClick">
      <el-tab-pane label="外发" name="first">
        <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="100px" size="mini">
        <div class=" inpBox">
          <el-form-item label="创建时间:" prop="">
                <el-date-picker
                  v-model="searchFrom.collectPlanStartTime"
                  size="mini"
                  style="width: 190px"
                  placeholder="选择日期"
                  type="date"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>&nbsp;-&nbsp;&nbsp;
                <el-date-picker
                  v-model="searchFrom.collectPlanEndTime"
                  size="mini"
                  style="width: 190px"
                  placeholder="选择日期"
                  type="date"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
                </el-form-item>
               <el-form-item label="客户名称:" prop="customerName">
                <el-input  placeholder="" maxlength="100" v-model="searchFrom.customerName"></el-input>
              </el-form-item>
              <el-form-item label="合同编号:" prop="contractNo">
                <el-input  placeholder="" maxlength="100" v-model="searchFrom.contractNo"></el-input>
              </el-form-item>
              <!-- <el-form-item label="承运车队:" prop="fleetCode">
                <el-select v-model="searchFrom.fleetCode" placeholder="请选择">
                 <el-option
                    v-for="(item,index) in fleetOptions"
                    :key="index"
                    :label="item.tenantName"
                    :value="item.tenantCode">
                  </el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="计重方式:" prop="weightFlg">
                <el-select v-model="searchFrom.weightFlg" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in weightFlgOptions"
                    :key="index"
                    :label="item.showName"
                    :value="item.itemNo">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="状态:" prop="planStatus">
                <el-select v-model="searchFrom.planStatus" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in waiFaPlanStatusOptions"
                    :key="index"
                    :label="item.showName"
                    :value="item.itemNo">
                  </el-option>
                </el-select>
              </el-form-item>
        </div>
       <div class="searchBtnBox">
        <el-form-item>
          <el-button type="primary" @click="searchClick" btnCode='00DP001B001' v-if="btnFlg[0]">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="chongZhiClick" btnCode='00DP001B002' v-if="btnFlg[1]" >重置</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="addBtnClick" btnCode='00DP001B003' v-if="btnFlg[2]" >新增</el-button>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="waiFaFinish" btnCode='00DP001B00J' v-if="btnFlg[14]" >完成</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="waiFaUnFinish" btnCode='00DP001B00K' v-if="btnFlg[15]" >撤销完成</el-button>
        </el-form-item>
       </div>
      </el-form>
    </div>
    <div class="tongJi">
      <div class="tongJi_item">
        已开交货：<span>{{waiFaJiaoHuo}}</span>&nbsp;&nbsp;吨
      </div>
      <div class="tongJi_item">
       出货量：<span>{{waiFaChuHuo}}</span>&nbsp;&nbsp;吨
      </div>
      <!-- 已开交货-出货量 -->
      <div class="tongJi_item">
        未完成：<span>{{(waiFaJiaoHuo - waiFaChuHuo).toFixed(3)}}</span>&nbsp;&nbsp;吨
      </div>
    </div>
    <div class="table" :style="{height:h}" v-loading="tableLoading2">
      <el-table
        :data="tableList"
        ref="tableList"
        border
        bordersize="mini"
        height="91%"
        style="width: 100%;margin-top:10px;"
        center
        @row-click = 'handleRowClick'
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="customerName" label="操作" width="130" align="center">
          <template slot-scope="scope"><div>
              <!-- <el-button @click="releaseHandleClick(scope.row)" btnCode='00DP001B005' v-if="scope.row.planStatus == '1' && btnFlg[4]"  type="text" size="small">发布</el-button> -->
              <!-- <el-button @click="changeHandleClick(scope.row)" btnCode='00DP001B004' v-if="scope.row.newFlg == '1' && scope.row.planStatus == '1'  && btnFlg[3]" type="text" size="small">修改</el-button> -->
              <!-- <el-button @click="delHandleClick(scope.row)" v-if="scope.row.planStatus == '1'" type="text" size="small">删除</el-button> -->
              <!-- <el-button @click="revokeHandleClick(scope.row)" btnCode='00DP001B006' v-if="scope.row.planStatus == '2' && btnFlg[5] && scope.row.newFlg != '1'" type="text" size="small">撤销</el-button> -->
              <el-button @click="detailsClick(scope.row)" type="text"  btnCode='00DP001B00N' size="small" v-if="btnFlg[16]">详情</el-button>
              <el-button @click="waybillHandleClick(scope.row)" type="text" btnCode='00DP001B008' v-if="btnFlg[7]" size="small" >运单</el-button>
            </div></template>
        </el-table-column>
        <el-table-column prop="planNo" label="计划编号" align="center" width="220" show-overflow-tooltip></el-table-column>
        <el-table-column prop="customerName" label="客户名称" align="center" width="220" show-overflow-tooltip></el-table-column>
        <el-table-column prop="contractNo" label="合同编号" align="center" width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="flowtoType" label="流向" align="center" width="140" show-overflow-tooltip>
          <template slot-scope="scope"><div>
            <span v-if="scope.row.flowtoType == '1'">外发</span>
            <span v-if="scope.row.flowtoType == '2'">集港</span>
            <span v-if="scope.row.flowtoType == '3'">倒中钢库</span>
            <span v-if="scope.row.flowtoType == '4'">倒兴泰库</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="fleetName" label="车队"  width="220" align="center" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="canpayWeight" label="已开交货"  width="170" align="center" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="totalAllowOut" label="出货量"  width="170" align="center" :formatter="emptyFn"></el-table-column>
        <!-- 已开交货-出货量 = 未完成 -->
        <el-table-column prop="" label="未完成"  align="center" width="140">
          <template slot-scope="scope">
            <span>{{(scope.row.canpayWeight - scope.row.totalAllowOut).toFixed(3)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="loadWeight" label="预出库"  width="170" align="center" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="inventoryWeight" label="可发库存"  width="170" align="center" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="planWeight" label="可装配" align="center" width="140" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="allData4"  label="完成率（%）" align="center" width="140" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="weightFlg"  label="计重方式" align="center" width="100">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.weightFlg=='A'">实重</span>
            <span v-else>理重</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="planStatus" label="状态" align="center" width="140">
          <!-- 1未完成  2已完成 -->
          <template slot-scope="scope"><div>
            <span v-if="scope.row.planStatus=='1'">未完成</span>
            <span v-if="scope.row.planStatus=='2'">已完成</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="createTime"  label="创建时间" align="center" width="180" :formatter="emptyFn">
          <template slot-scope="scope">
            <span>{{scope.row.createTime | dateFormat}}</span>
          </template>
        </el-table-column>
        <el-table-column prop=""  label="完成时间" align="center" width="180" :formatter="emptyFn">
          <template slot-scope="scope">
            <span>{{scope.row.finishTime | dateFormat}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div >
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[10,25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total1">
      </el-pagination>
    </div>
      </el-tab-pane>
      <el-tab-pane label="集港" name="second">
         <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="secondFrom" ref="secondFrom" class="demo-form-inline" label-width="100px" size="mini">
        <div class=" inpBox">
          <el-form-item label="创建时间:" prop="">
                <el-date-picker
                  v-model="secondFrom.collectPlanStartTime"
                  size="mini"
                  style="width: 190px"
                  placeholder="选择日期"
                  type="date"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>&nbsp;-&nbsp;&nbsp;
                <el-date-picker
                  v-model="secondFrom.collectPlanEndTime"
                  size="mini"
                  style="width: 190px"
                  placeholder="选择日期"
                  type="date"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
                </el-form-item>
               <el-form-item label="客户名称:" prop="customerName">
                <el-input  placeholder="" maxlength="100" v-model="secondFrom.customerName"></el-input>
              </el-form-item>
              <el-form-item label="合同编号:" prop="contractNo">
                <el-input  placeholder="" maxlength="100" v-model="secondFrom.contractNo"></el-input>
              </el-form-item>
              <el-form-item label="流向:" prop="flowtoType">
                <el-select v-model="secondFrom.flowtoType" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in liuXiangOptions"
                    :key="index"
                    :label="item.showName"
                    :disabled="item.itemNo == 1"
                    :value="item.itemNo">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="计重方式:" prop="weightFlg">
                <el-select v-model="secondFrom.weightFlg" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in weightFlgOptions"
                    :key="index"
                    :label="item.showName"
                    :value="item.itemNo">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="状态:" prop="planStatus">
                <el-select v-model="secondFrom.planStatus" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in waiFaPlanStatusOptions"
                    :key="index"
                    :label="item.showName"
                    :value="item.itemNo">
                  </el-option>
                </el-select>
              </el-form-item>
        </div>
       <div class="searchBtnBox">
        <el-form-item>
          <el-button type="primary" @click="secondQueryClick" btnCode='00DP001B009' v-if="btnFlg[8]">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="secondResetClick" btnCode='00DP001B00A' v-if="btnFlg[9]">重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="dispatchCarClick" btnCode='00DP001B00B' v-if="btnFlg[10]">派车</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="dispatchSettingClick" btnCode='00DP001B00C' v-if="btnFlg[11]">自动派车设置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="jiGangFinish" btnCode='00DP001B00L' :disabled = 'jiGangFinishBtn' v-if="btnFlg[17]" >完成</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="jiGangUnFinish" btnCode='00DP001B00M' :disabled = 'jiGangUnFinishBtn' v-if="btnFlg[18]" >撤销完成</el-button>
        </el-form-item>
       </div>
      </el-form>
    </div>
    <div class="tongJi">
      <div class="tongJi_item">
        已开交货：<span>{{jiGangJiaoHuo}}</span>&nbsp;&nbsp;吨
      </div>
      <div class="tongJi_item">
       出货量：<span>{{jiGangChuHuo}}</span>&nbsp;&nbsp;吨
      </div>
      <!-- 已开交货-出货量 -->
      <div class="tongJi_item">
       未完成：<span>{{(jiGangJiaoHuo - jiGangChuHuo).toFixed(3)}}</span>&nbsp;&nbsp;吨
      </div>
    </div>
    <!-- 表格 -->
    <div class="table" :style="{height:h}" v-loading="tableLoading2">
      <el-table
        :data="secondtableData"
        ref="secondtableData"
        border
        bordersize="mini"
        height="91%"
        style="width: 100%;margin-top:10px;"
        center
        @row-click = 'secondHandleRowClick'
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop=""    label="操作" width="130" align="center">
          <template slot-scope="scope"><div>
            <el-button @click="secondPlanDetails(scope.row)" type="text" size="small"  btnCode='00DP001B00G' v-if="btnFlg[13]" >详情</el-button>
            <el-button @click="secondWaybillHandle(scope.row)" type="text" size="small"  btnCode='00DP001B00D' v-if="btnFlg[12]">运单</el-button>
          </div></template>
        </el-table-column>
        <el-table-column property="planNo" label="计划编号"  align="center" width="220" show-overflow-tooltip></el-table-column>
        <el-table-column prop="customerName"    label="客户名称" align="center" width="220" show-overflow-tooltip></el-table-column>
        <el-table-column prop=""  label="合同编号" align="center" width="170" show-overflow-tooltip>
          <template slot-scope="scope"><div> 
            <span v-if="scope.row.count > '1'">理计合同</span>
            <span v-else-if="scope.row.count == '1'">{{scope.row.contractNo}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="flowtoType" label="流向" align="center" width="140" show-overflow-tooltip>
          <template slot-scope="scope"><div>
            <span v-if="scope.row.flowtoType == '1'">外发</span>
            <span v-if="scope.row.flowtoType == '2'">集港</span>
            <span v-if="scope.row.flowtoType == '3'">倒中钢库</span>
            <span v-if="scope.row.flowtoType == '4'">倒兴泰库</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="canpayWeight" label="已开交货"  width="100" align="center" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="totalAllowOut" label="出货量"  width="100" align="center" :formatter="emptyFn"></el-table-column>
        <!-- 已开交货-出货量 = 未完成 -->
        <el-table-column prop="" label="未完成"  align="center" width="140">
          <template slot-scope="scope">
            <span>{{(scope.row.canpayWeight - scope.row.totalAllowOut).toFixed(3)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="loadWeight"  label="预出库" align="center" width="110" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="inventoryWeight" label="可发库存" align="center" width="110" :formatter="emptyFn">
          <!-- <template slot-scope="scope">
            <span v-if="scope.row.planStatus=='2'">-</span>
            <span v-else>{{scope.row.inventoryWeight}}</span>
          </template> -->
        </el-table-column>
        <el-table-column prop="planWeight" label="可装配" align="center" width="140" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="allData4"  label="完成率（%）" align="center" width="140" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="weightFlg"  label="计重方式" align="center" width="100">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.weightFlg=='A'">实重</span>
            <span v-else>理重</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="planStatus" label="状态" align="center" width="140">
          <!-- 1未完成  2已完成 -->
          <template slot-scope="scope"><div>
            <span v-if="scope.row.planStatus=='1'">未完成</span>
            <span v-if="scope.row.planStatus=='2'">已完成</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="createTime"  label="创建时间" align="center" width="180" :formatter="emptyFn">
          <template slot-scope="scope">
            <span>{{scope.row.createTime | dateFormat}}</span>
          </template>
        </el-table-column>
        <el-table-column prop=""  label="完成时间" align="center" width="180" :formatter="emptyFn" v-if="planStatus != '1'">
          <template slot-scope="scope">
            <span>{{scope.row.finishTime | dateFormat}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div >
      <el-pagination background
        @size-change="handleSizeChangeB"
        @current-change="handleCurrentChangeB"
        :current-page="secondFrom.pageNo"
        :page-sizes="[10,25,50,100]"
        :page-size="secondFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total2">
      </el-pagination>
    </div>
    <!--自动派车设置弹框-->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    @close="closeDispatchDialog"
    :close-on-press-escape="false"
    :visible.sync="dispatchSettingMark"
    width="500px"
    center>
      <span>
        <div style="display:flex;width:180px;margin:20px auto;">
          <div>当前状态：</div>
          <div style="color:red;font-weight: 700;">{{statusValue}}</div>
        </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button :disabled='stopDispatcherCar' v-if="statusCode == 1"  type="primary"  size='mini' @click="stopAutoDispatcher">暂停自动派车</el-button>
        <el-button :disabled='startDispatcherCar' v-if="statusCode == 2"  type="primary"  size='mini' @click="startAutoDispatcher">启动自动派车</el-button>
        <el-button   size='mini' @click="closeDispatchDialog" >关闭</el-button>
      </span>
    </el-dialog>
    </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import {
  TenantDictionary, // 字典/
  tCollectPlanRelease, // 发布
  tCollectPlanQuXiaoRelease, // 取消发布
  deletePlan,   // 删除
  stopAutoDispatcherCar, // 停止自动派车
  startAutoDispatcherCar, // 启动自动派车
  autoDispatcherCarStatus, // 自动派车的状态
  jiChuGuanLiChangeFleet, // 车队下拉框
  getManualDispatchCarInfo, //获取集港计划页面点击派车获取
  // 1.5版
  planInfo,  // 计划列表查询
  planComplete,  // 计划完成/未完成
  statisticForPlanManage   // 统计量
} from '@/api/zhb'
import { getBtn } from '@/utils/getButton'
import { encryption, emptyFn } from '@/utils/util'
import DonMessage from '@/utils/message'
export default {
  data () {
    return {
      emptyFn: emptyFn,
      // 按钮
      btnFlg: [],
      btnIdArr: ['00DP001B001', '00DP001B002', '00DP001B003','00DP001B004', '00DP001B005', 
                '00DP001B006', '00DP001B007','00DP001B008','00DP001B009','00DP001B00A',
                '00DP001B00B','00DP001B00C','00DP001B00D','00DP001B00G','00DP001B00J',
                '00DP001B00K','00DP001B00N','00DP001B00L','00DP001B00M'],
      activeName: 'first',
      waiFaJiaoHuo: 0,
      waiFaChuHuo: 0,
      faHuoLiang: 0,
      wanChengLv: 0,
      title: '',
      h: '500px',
      searchFrom: {
        pageNo: 1,
        pageSize: 10,
        flowtoType:'1',  //1-外发 2集港
        collectPlanStartTime:'',
        collectPlanEndTime:'',
        planStatus:'1'
      },
      waiFaPlanStatusOptions:[
        {
          showName:'未完成',
          itemNo:'1'
        },
        {
          showName:'已完成',
          itemNo:'2'
        }
      ],
      total1: 0,
      fleetOptions:[], // 车队
      liuXiangOptions: [],
      // 计重方式
      weightFlgOptions:[
        {
          showName:'理重',
          itemNo:'T'
        },
        {
          showName:'实重',
          itemNo:'A'
        }
      ],
      value: '',
      tableList: [],
      // 新增
      addShengChengLoading: false,
      addFaBuLoading: false,
      // 修改
      changeFlag: '', // 1自动  2 手动
      changeData: {}, // 修改需携带的数据
      faBuId: '',
      planStatus: '',
      // 集港
      secondFrom:{
        pageNo: 1,
        pageSize: 10,
        flowtoType:'',  //1-外发 2集港
        collectPlanStartTime:'',
        collectPlanEndTime:'',
        weightFlg:'',
        planStatus:'1'
      },
      total2: 0,
      secondtableData:[],
      jiGangZhuangPei:0,
      jiGangJiaoHuo:0,
      jiGangChuHuo:0,
      // 自动派车设置
      dispatchSettingMark:false,
      statusValue:'',
      statusCode:'',
      stopDispatcherCar:false,
      startDispatcherCar:false,
      rowSelected:{}, //保存集港Tab页的被选中的那一行的对象
      nowDate:'',
      spanArr:[],
      tableLoading:false,
      tableLoading2:false,
      jiGangFinishBtn:false,
      jiGangUnFinishBtn:false
    }
  },
  created () {
    this.getToDay()
    this.getSeatchData(this.searchFrom)
    this.statisticForPlanManage(this.searchFrom)
    this.getDictionary()
    // this.getFleet()
    this.btnFlg = getBtn(this.btnIdArr, '/planManagement')
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 150) + 'px'
  },
  methods: {
    // 获取车队下拉框数据
    getFleet(){
      // 车队下拉框
      jiChuGuanLiChangeFleet().then(res => {
        this.fleetOptions = res
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // tab切换
    tabHandleClick (tab, event) {
      // console.log(tab, event)
      if (tab.index == 0) {
        this.getToDay()
        this.getSeatchData(this.searchFrom);
        this.statisticForPlanManage(this.searchFrom)
      } else if (tab.index == 1) {
        this.getToDay()
        this.getSecondData(this.secondFrom)
        this.statisticForPlanManage2(this.secondFrom)
      }
      this.rowSelected={}//重置保存的集港Tab页的被选中的对象
    },
    // 年月日格式化
    timeStamp: function (value) {
      if (!value) return ''
      var now = new Date(value)
      // console.log('time:' + JSON.stringify(now))
      var year = now.getFullYear()
      var month = now.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var date = now.getDate()
      if (date < 10) {
        date = '0' + date
      }
      return year + '-' + month + '-' + date
    },
    /**
 * 日期格式化
 */
    dateFormat (date) {
      let format = 'yyyy-MM-dd hh:mm:ss'
      if (date != 'Invalid Date') {
        var o = {
          'M+': date.getMonth() + 1, // month
          'd+': date.getDate(), // day
          'h+': date.getHours(), // hour
          'm+': date.getMinutes(), // minute
          's+': date.getSeconds(), // second
          'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
          'S': date.getMilliseconds() // millisecond
        }
        if (/(y+)/.test(format)) {
          format = format.replace(RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1,
              RegExp.$1.length == 1 ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length))
          }
        }
        return format
      }
      return ''
    },
    // 计划开始时间-当前日期早8点
    getToDay () {
      //前一月
      var now = new Date();
      var month1 = now.setMonth(now.getMonth()-1); 
      this.searchFrom.collectPlanStartTime = this.timeStamp(month1); 
      this.secondFrom.collectPlanStartTime = this.timeStamp(month1); 
      this.searchFrom.collectPlanEndTime = this.timeStamp(new Date())
      this.secondFrom.collectPlanEndTime = this.timeStamp(new Date())
      // 早八点之前显示昨天的日期，早八点之后显示今天的日期
      let dateStartStr = this.dateFormat(new Date(new Date(new Date().toLocaleDateString()).getTime() + 28800000)) // 当天的早8点时间戳
      let dateEndStr = this.dateFormat(new Date(new Date(new Date().toLocaleDateString()).getTime() + 43200000 * 3 - 14400000)) // 当天的早8点时间戳
      this.nowDate = (new Date()).getTime()
      let morningTime = new Date(dateStartStr).getTime()
      // if (this.nowDate > morningTime) {
      //   this.searchFrom.collectPlanStartTime = this.timeStamp(new Date())
      //   this.searchFrom.collectPlanEndTime = this.timeStamp(new Date())
      //   this.secondFrom.collectPlanStartTime = this.timeStamp(new Date())
      //   this.secondFrom.collectPlanEndTime = this.timeStamp(new Date())
      // } else {
      //   // 昨天的时间
      //   var day1 = new Date()
      //   day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000)
      //   var s1 = day1.getFullYear() + '-' + (day1.getMonth() + 1) + '-' + day1.getDate()
      //   this.searchFrom.collectPlanStartTime = this.timeStamp(new Date())
      //   this.searchFrom.collectPlanEndTime = this.timeStamp(new Date())
      //   this.secondFrom.collectPlanStartTime = s1
      //   this.secondFrom.collectPlanEndTime = s1
      // }
    },
    // 获取流向字典数据
    getDictionary () {
      TenantDictionary({
        groupNo: 'flowto_type'
      }).then(res => {
        this.liuXiangOptions = res
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 外发查询接口
    getSeatchData () {
      this.tableLoading = true
      planInfo(this.searchFrom).then(res => {
        this.tableLoading = false
        if (res.list != []) {
          this.$nextTick(()=>{
            this.tableList = res.list
            this.total1 = res.total
          })
        }
      }).catch(err => {
        this.tableLoading = false
        console.log(err.message)
        this.$message.error(err.message)
      })
    },
    // 已开交货/出货量统计
    statisticForPlanManage(){
      statisticForPlanManage(this.searchFrom).then(res => {
        if(res != null){
          this.waiFaJiaoHuo = res.totalCanpayWeight
          this.waiFaChuHuo = res.totalLoadWeight
        }else{
          this.waiFaJiaoHuo = 0
          this.waiFaChuHuo = 0
        }
      }).catch(err => {
        console.log(err.message)
        this.$message.error(err.message)
      })
    },
     // 集港查询接口
    getSecondData () {
      this.tableLoading2 = true
      this.rowSelected={}//重置集港Tab页的被选中的对象
      planInfo(this.secondFrom).then(res => {
        this.tableLoading2 = false
        if (res.list == []) {
          // this.jiGangJiaoHuo = 0
          // this.jiGangZhuangPei = 0
        } else {
          this.secondtableData = res.list
          this.total2 = res.total
          // this.jiGangPlan = this.secondtableData[0].allData1
          // this.jiGangZhuangPei = this.secondtableData[0].allData3
        }
      }).catch(err => {
        this.tableLoading2 = false
        console.log(err.message)
        this.$message.error(err.message)
      })
    },
    // 已开交货/出货量统计
    statisticForPlanManage2(){
      statisticForPlanManage(this.secondFrom).then(res => {
        if(res != null){
          this.jiGangJiaoHuo = res.totalCanpayWeight
          this.jiGangChuHuo = res.totalLoadWeight
        }else{
          this.jiGangJiaoHuo = 0
          this.jiGangChuHuo = 0
        }
      }).catch(err => {
        console.log(err.message)
        this.$message.error(err.message)
      })
    },
    // 点击外发查询按钮
    searchClick () {
      this.getSeatchData(this.searchFrom)
      this.statisticForPlanManage(this.searchFrom)
    },
    // 点击集港查询
    secondQueryClick(){
      this.getSecondData(this.secondFrom)
      this.statisticForPlanManage2(this.secondFrom)
    },
    // 点击外发重置
    chongZhiClick () {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 10,
        collectPlanStartTime:'',
        collectPlanEndTime:'',
        flowtoType:'1'  //1-外发 2集港
      }
      this.getToDay()
      this.getSeatchData(this.searchFrom)
      this.statisticForPlanManage(this.searchFrom)
    },
    // 点击集港重置
    secondResetClick () {
      this.secondFrom = {
        pageNo: 1,
        pageSize: 10,
        collectPlanStartTime:'',
        collectPlanEndTime:'',
        flowtoType:''  //1-外发 2集港
      }
      this.getToDay()
      this.getSecondData(this.secondFrom)
      this.statisticForPlanManage2(this.secondFrom)
    },
    // 每页条数 - 外发
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getSeatchData()
    },
    // 当前页 - 外发
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getSeatchData()
    },
    // 每页条数 - 集港
    handleSizeChangeB (val) {
      this.secondFrom.pageSize = val
      this.getSecondData(this.secondFrom)
    },
    // 当前页 - 集港
    handleCurrentChangeB (val) {
      this.secondFrom.pageNo = val
      this.getSecondData(this.secondFrom)
    },
    // 点击选中
    handleRowClick (row) {
      // console.log(row)
      this.$refs.tableList.toggleRowSelection(row)
      this.changeFlag = row.newFlg
      this.changeData = row
      this.faBuId = row.id
      this.planStatus = row.planStatus
      // comsole.log(row,'当前行')
    },
    secondHandleRowClick(row){
      this.rowSelected=row
      this.$refs.secondtableData.toggleRowSelection(row)
      if (this.rowSelected.flowtoType!= '1'&&this.rowSelected.weightFlg=='T'){
        this.jiGangFinishBtn = true
        this.jiGangUnFinishBtn = true
      }else{
        this.jiGangFinishBtn = false
        this.jiGangUnFinishBtn = false
      }
    },
    // 点击修改按钮
    changeHandleClick (row) {
      localStorage.setItem('changeData', JSON.stringify(row)) 
      this.$router.push({ name: 'planManagementChange' })
      // this.$router.push({
      //   name: 'planManagementChange',
      //   params: {
      //     changeData: row
      //   }
      // })
    },
    // 点击发布按钮
    releaseHandleClick (row) {
      tCollectPlanRelease({
      id: row.id
      }).then(res => {
        this.$message.success('发布成功！')
        this.getSeatchData(this.searchFrom)
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 点击撤销发布
    revokeHandleClick (row) {
      tCollectPlanQuXiaoRelease({
        id: row.id
      }).then(res => {
        this.$message.success('撤销发布成功！')
        this.getSeatchData(this.searchFrom)
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 点击删除按钮
    delHandleClick(row){
       deletePlan({
        id: row.id
      }).then(res => {
        this.$message.success('删除成功！')
        this.getSeatchData(this.searchFrom)
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 点击运单详情 
    waybillHandleClick(row){
      localStorage.setItem('rowData', JSON.stringify(row)) 
      this.$router.push({ name: 'dispatchCarSee' })
      // this.$router.push({
      //   name: 'dispatchCarSee',
      //   params: {
      //     rowData: row
      //   }
      // })
    },
    // 点击新建按钮
    addBtnClick () {
      this.$router.push('/planManagementAdd')
    },
    // 合同列表取消
    heTongQuXiaoClick () {
      this.heTongMark = false
    },
    // 每页条数
    handleSizeChange2 (val) {
      this.heTongFrom.pageSize = val
      // this.getSearchData()
    },
    // 当前页
    handleCurrentChange2 (val) {
      this.heTongFrom.pageNo = val
      // this.getSearchData()
    },
    // 点击列表查看
    chaKanHandleClick (row) {
      localStorage.setItem('rowData1', JSON.stringify(row)) 
      this.$router.push({ name: 'planManagementSee' })
      // this.$router.push({
      //   name: 'planManagementSee',
      //   params: {
      //     rowData: row
      //   }
      // })
    },
    // 点击自动派车设置
    dispatchSettingClick(){
      this.dispatchSettingMark = true
      this.title = '自动派车设置'
      this.getAutoDispatcherCarStatus()
    },
    // 获取自动派车的状态
    getAutoDispatcherCarStatus(param){
      autoDispatcherCarStatus().then(res => {
        this.statusValue=res.statusValue
        this.statusCode=res.statusCode
        if (param==1) {
          this.$message.success('自动派车暂停成功')
        }else if (param==2) {
          this.$message.success('启动自动派车成功')
        }
        this.stopDispatcherCar=false
        this.startDispatcherCar=false
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 关闭自动派车的弹窗
    closeDispatchDialog(){
      this.statusValue=''
      this.statusCode=''
      this.stopDispatcherCar=false
      this.startDispatcherCar=false
      this.dispatchSettingMark = false
    },
    // 暂停自动派车
    stopAutoDispatcher(){
      this.stopDispatcherCar=true
      stopAutoDispatcherCar().then(res => {
        this.getAutoDispatcherCarStatus(1)
      }).catch(err => {
        this.$message.error(res.message)
      })
    },
    // 启动自动派车
    startAutoDispatcher(){
      this.startDispatcherCar=true
      startAutoDispatcherCar().then(res => {
        this.getAutoDispatcherCarStatus(2)
      }).catch(err => {
        this.$message.error(res.message)
      })
    },
    // 点击集港列表运单
    secondWaybillHandle(row){
      localStorage.setItem('rowData', JSON.stringify(row)) 
      this.$router.push({ name: 'dispatchCarSee' })
      // this.$router.push({
      //   name: 'dispatchCarSee',
      //   params: {
      //     rowData: row
      //   }
      // })
    },
    // 点击计划详情
    secondPlanDetails(row){
      localStorage.setItem('rowData', JSON.stringify(row)) 
      this.$router.push({ name: 'planManagementSee' })
    },
    //点击集港Tab页的派车按钮
    dispatchCarClick(){
      if (this.rowSelected.planNo==null||this.rowSelected.planNo==undefined||this.rowSelected.planNo=='') {
        this.$message.error("请选择一条集港计划进行派车")
        return
      }
      // if(this.rowSelected.planStatusShow == '已结束'){
      //   this.$message.error("该条数据状态不能派车！")
      // }else{

        let par={
            planNo:''
        }
        par.planNo=this.rowSelected.planNo
        console.log(this.rowSelected.planNo)
        this.$router.push({ 
          name: 'dispatchCarAdd',
          params: par
        }) 
          // getManualDispatchCarInfo(params).then(res => {
          //   console.log(res)       
          //   localStorage.setItem('params', JSON.stringify(res)) 
                  
          //   // this.$router.push({
          //   //   name:'dispatchCarAdd',
          //   //   params:res
          //   // })
          // }).catch(err => {
          //   this.$message.error(err.message)
          // })
      // }
      
    },
    // 点击外发详情
    detailsClick(row){
      localStorage.setItem('rowData', JSON.stringify(row)) 
      this.$router.push({ name: 'dispatchCarAddMany' })
    },
    // 点击外发完成
    waiFaFinish(){
      if (this.changeData.planNo==null||this.changeData.planNo==undefined||this.changeData.planNo=='') {
        this.$message.error("请选择一条外发计划进行操作")
      }else if(this.changeData.planStatus == '2'){
        this.$message.error("已完成的合同不可操作！")
      } else{
        this.$confirm('计划完成后不可派车，请确认是否完成？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          planComplete({
            id:this.changeData.ids,
            planStatus: 2
          })
            .then(res => {
              DonMessage.success('操作成功!')
              this.getSeatchData()
            })
            .catch(err => {
              DonMessage.error(err.message)
            })
        })
        .catch(() => {})
      }
    },
    // 点击外发撤销完成
    waiFaUnFinish(){
      if (this.changeData.planNo==null||this.changeData.planNo==undefined||this.changeData.planNo=='') {
        this.$message.error("请选择一条外发计划进行操作")
      }else if(this.changeData.planStatus == '1'){
        this.$message.error("未完成的合同不可操作！")
      }else{
        this.$confirm('是否确定此操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          planComplete({
            id:this.changeData.ids,
            planStatus: 1
          })
            .then(res => {
              DonMessage.success('操作成功!')
              this.getSeatchData()
            })
            .catch(err => {
              DonMessage.error(err.message)
            })
        })
        .catch(() => {})
      }
    },
    // 点击集港完成   
    jiGangFinish(){
      if (this.rowSelected.planNo==null||this.rowSelected.planNo==undefined||this.rowSelected.planNo=='') {
        this.$message.error("请选择一条集港计划进行操作")
      } else if(this.rowSelected.planStatus == '2'){
        this.$message.error("已完成的合同不可操作！")
      } else{
        this.$confirm('计划完成后不可派车，请确认是否完成？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          type: 'warning'
        })
        .then(() => {
          planComplete({
            id:this.rowSelected.ids,
            planStatus: 2
          })
            .then(res => {
              DonMessage.success('操作成功!')
              this.getSecondData()
            })
            .catch(err => {
              DonMessage.error(err.message)
            })
        })
        .catch(() => {})
      }
    },
    // 点击集港撤销完成
    jiGangUnFinish(){
      if (this.rowSelected.planNo==null||this.rowSelected.planNo==undefined||this.rowSelected.planNo=='') {
        this.$message.error("请选择一条集港计划进行操作")
      }else if(this.rowSelected.planStatus == '1'){
        this.$message.error("未完成的合同不可操作！")
      } else{
        this.$confirm('是否确定此操作？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          type: 'warning'
        })
        .then(() => {
          planComplete({
            id:this.rowSelected.ids,
            planStatus: 1
          })
            .then(res => {
              DonMessage.success('操作成功!')
              this.getSecondData()
            })
            .catch(err => {
              DonMessage.error(err.message)
            })
        })
        .catch(() => {})
      }
    }
  }
}
</script>
<style scoped lang='less'>
/deep/ .el-tabs__item {
  width:150px;
  text-align: center;
  // background-color:#ccc ;
}
/deep/ .is-active{
  background-color:#409EFF;
  color: #fff;
}
.el-table{
overflow:visible !important;
width:99.9%!important;
}
.searchBox{
  margin-left: 10px;
}
.inpBox{
  margin: 10px 0 0 -30px;
  
}

 /deep/ .inpBox .el-range-editor--mini .el-input__inner {
   width: 150px;
}
.searchBtnBox{
  margin-top: 10px;
}
.el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 40px;
}
//  .demo-form-inline .el-form-item{
//   margin-bottom: 17px!important;
// }
.tongJi{
  display: flex;
  margin-left:10px;
}
.tongJi_item{
  margin-right: 20px;
}
.tongJi_item span{
  color: red;
}
</style>
